module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "Normal CharOverride-4"
  }, [_vm._v("This book is dedicated to")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v(" my loving parents, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("John and Mary Ferrell, who found and adopted me at birth. Without their unconditional love, encouragement, and support, I would not be where I am today. John and Mary are now gone, but they are always in my thoughts and greatly missed. Their unique parenting taught me many things about love, learning, and life. I was raised to respect all people, especially my elders. I learned at an early age to say “thank you” and mean it. I was taught not to be heard but to listen—and to always tell the truth. My parents would be grateful for this virtue and proud that I try to live by the golden rule. When I turned fifty a few years ago, I realized that I had inherited the same trait my father complained of having: never knowing what or when something is going to come out of my mouth! My good friends "), _c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Ruth and Ruby Crawford solved my problem by offering their mother’s wise advice: “Always tell the truth . . . but don’t always be telling it.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph t ParaOverride-1"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("Thanks also to my partner, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  }), _vm._v("Hank Thompson, who came into my life just before my fiftieth birthday. Hank is one of the happiest people I have ever met and a perfect complement to my life and to Mary Mac’s. We often feel that our mothers—who knew their boys well—must have met in heaven and had a wonderful time planning our life together as the perfect match! We have many things in common, including being adopted and growing up as an only child in a loving home. We were both raised in small communities in the South and had the same values instilled in us by our parents. Of course, we both love Southern food, and while some people may eat to live, we live to eat! Hank’s love for Mary Mac’s Tea Room, his keen business sense, his unique ability to listen and solve problems, and his skill at motivating me and the staff, are a constant blessing. ")]), _c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("I have the best business partner a man could have . . . all thanks to our sweet mamas, Mary and Alice!")])]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph t ParaOverride-1"
  }, [_c('span', {
    staticClass: "Normal CharOverride-3"
  }, [_vm._v("I also want to mention that one of my biggest wishes was answered when my son, Matt, joined the Mary Mac’s family in 2010. His growth and hands-on appreciation for our business has been critical to our continued success. I am proud of what he has accomplished at Mary Mac’s and in his role as a board member for the Georgia Restaurant Association. My vision for Mary Mac’s to become a family business looks bright because Matt’s wife, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _vm._v("Elizabeth, approached me in 2014 and asked to join our team. Although she was trained and had a degree in environmental engineering, she didn’t have the same level of passion for the job she had at the time that Matt had for Mary Mac’s, and she wanted to become a part of our family business. Of course Hank and I were delighted to have her and I am so happy that Elizabeth is with us. Together she and Matt provide confidence that our family business will continue to thrive. I want to thank them for their hard work, dedication, and attention to detail, and I especially love that they are great young people that enjoy our business and love our guests!")])]), _vm._v(" "), _c('p', {
    staticClass: "Normal t c"
  }, [_c('span', {
    staticClass: "Normal CharOverride-5"
  }), _c('span', {
    staticClass: "Normal CharOverride-4"
  }, [_vm._v("—")]), _c('span', {
    staticClass: "Normal CharOverride-6"
  }, [_vm._v("John Ferrell")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 t"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "alt": "",
      "src": "image/cornbread2_cc.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1 pb"
  }, [_c('div', {
    staticClass: "_idGenObjectStyle-Disabled",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/ABD_MaryMacs-10.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181bb014","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mary_Mac_Final_epub-2.vue
// module id = 63
// module chunks = 0